import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconSignOut(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7 1.5H9C9.82843 1.5 10.5 2.17157 10.5 3V9C10.5 9.82843 9.82843 10.5 9 10.5H7" stroke="currentColor" />
      <path d="M4.5 3L7.5 6L4.5 9" stroke="currentColor" />
      <path d="M1 6H7.5" stroke="currentColor" />
    </SVGIcon>
  );
}
